/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section2title2Inputs */

const id_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Tujuan Penggunaan Wajar`)
};

const ms_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Tujuan Penggunaan Adil`)
};

const da_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Formål med Fair Use`)
};

const de_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Zweck der fairen Nutzung`)
};

const en_us2_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Purpose of Fair Use`)
};

const es_es2_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Propósito del uso justo`)
};

const es_mx2_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Propósito del uso justo`)
};

const fil_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Layunin ng Patas na Paggamit`)
};

const fr_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Objectif de l'utilisation équitable`)
};

const it_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Scopo del Fair Use`)
};

const hu_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. A Fair Use célja`)
};

const nl_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Doel van Fair Use`)
};

const no_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Formål med rimelig bruk`)
};

const pl_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Cel dozwolonego użytku`)
};

const pt_br2_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Finalidade do Uso Justo`)
};

const pt_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Objetivo do Uso Justo`)
};

const ro_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Scopul utilizării corecte`)
};

const fi_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Kohtuullisen käytön tarkoitus`)
};

const sv_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Syfte med skälig användning`)
};

const vi_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Mục đích của sử dụng hợp lý`)
};

const tr_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Adil Kullanımın Amacı`)
};

const cs_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Účel spravedlivého použití`)
};

const bg_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Цел на честната употреба`)
};

const ru_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Цель добросовестного использования`)
};

const uk_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Мета добросовісного використання`)
};

const ar_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. الغرض من الاستخدام العادل`)
};

const hi_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. उद्देश्य`)
};

const th_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. วัตถุประสงค์ของการใช้งานโดยชอบ`)
};

const ja_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. フェアユースの目的`)
};

const zh_cn2_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 合理使用目的`)
};

const zh_hant1_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 合理使用目的`)
};

const ko_misc_fairuse_section2title2 = /** @type {(inputs: Misc_Fairuse_Section2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 공정 사용의 목적`)
};

/**
* | output |
* | --- |
* | "2. Purpose of Fair Use" |
*
* @param {Misc_Fairuse_Section2title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section2title2 = /** @type {((inputs?: Misc_Fairuse_Section2title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section2title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section2title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section2title2(inputs)
	if (locale === "da") return da_misc_fairuse_section2title2(inputs)
	if (locale === "de") return de_misc_fairuse_section2title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section2title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section2title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section2title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section2title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section2title2(inputs)
	if (locale === "it") return it_misc_fairuse_section2title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section2title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section2title2(inputs)
	if (locale === "no") return no_misc_fairuse_section2title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section2title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section2title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section2title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section2title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section2title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section2title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section2title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section2title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section2title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section2title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section2title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section2title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section2title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section2title2(inputs)
	if (locale === "th") return th_misc_fairuse_section2title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section2title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section2title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section2title2(inputs)
	return ko_misc_fairuse_section2title2(inputs)
});
export { misc_fairuse_section2title2 as "misc.fairUse.section2Title" }